/**
 * Project : workspace
 * File    : ProductDetailScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.product.detail

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.cart.viewModel.CartViewModel
import com.parmartechnologies.commerce.feature.inventory.product.viewModel.ProductViewModel
import com.parmartechnologies.commerce.feature.inventory.viewModel.inventory.InventoryViewModel
import com.parmartechnologies.core.feature.inventory.inventory.model.Inventory
import com.parmartechnologies.core.navigation.NavigationParam
import com.parmartechnologies.ui.component.image.ImageView
import component.button.DefaultButton
import component.button.SecondaryButton
import component.loader.AppLoader
import component.navigation.TopNavBar
import component.text.TextRow
import navigation.AppNavigator
import navigation.route.inventory.InventoryNavRoute
import presentation.screens.business.inventory.product.detail.component.ColorCard
import presentation.screens.business.inventory.product.detail.component.SizeCard
import presentation.screens.business.inventory.product.detail.component.UOMCard
import theme.ThemeColor

/**
 * Represents the product detail screen class.
 */

class ProductDetailScreen{
    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        val viewModel = ProductViewModel(myBusiness.value)
        val invViewModel = InventoryViewModel(myBusiness.value)
        val cartViewModel = CartViewModel(myBusiness.value)
        val product = AppNavigator.shared().getNavigationParam().product
        val productInventory = invViewModel.productInventory.collectAsState()
        val filteredInventory: MutableState<List<Inventory>> = remember {
            mutableStateOf(
                arrayListOf()
            )
        }
        val selectedInventory: MutableState<Inventory?> = remember {
            mutableStateOf(
                null
            )
        }
        

        val colorId = remember<MutableState<String>> { mutableStateOf("") }
        val sizeId = remember<MutableState<String>> { mutableStateOf("") }
        val uomId = remember<MutableState<String>> { mutableStateOf("") }

        /**
 * Executes the get distinct ids operation.
 *
 * @receiver TODO
 * @param items The items.
 * @param itemType The item type.
 * @return The resulting list< string?>.
 */

        fun getDistinctIds(items: List<Inventory>, itemType: String): List<String?> {
            if (itemType == "color") {
                return items.map { it.ColorID }.distinct()
            } else if (itemType == "size") {
                return items.map { it.SizeID }.distinct()
            } else {
                return items.map { it.UOMID }.distinct()

            }
        }

        val dColors = getDistinctIds(productInventory.value, "color")
        val dSize = getDistinctIds(productInventory.value, "size")
        val dUoM = getDistinctIds(productInventory.value, "uom")

        LaunchedEffect(key1 = Unit) {
            invViewModel.loadProductInventory(AppNavigator.shared().getNavigationParam())
        }
        /**
 * Executes the find by id operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
        fun findById() {
            invViewModel.findById(
                uomId = uomId.value,
                colorId = colorId.value,
                sizeId = sizeId.value,
                param = AppNavigator.shared().getNavigationParam()
            ) { data ->
                filteredInventory.value = data
            }
        }

        var lowestProduct: Inventory? = null
        var highestProduct: Inventory? = null
        var lowestMRPProduct: Inventory? = null
        var highestMRPProduct: Inventory? = null
        if (filteredInventory.value.isEmpty()) {
            lowestProduct = productInventory.value.minByOrNull { it.ProductPrice?.FinalPrice!! }
            highestProduct = productInventory.value.maxByOrNull { it.ProductPrice?.FinalPrice!! }
            lowestMRPProduct = productInventory.value.minByOrNull { it.ProductPrice?.MRP!! }
            highestMRPProduct = productInventory.value.maxByOrNull { it.ProductPrice?.MRP!! }
        } else {
            lowestProduct = filteredInventory.value.minByOrNull { it.ProductPrice?.FinalPrice!! }
            highestProduct = filteredInventory.value.maxByOrNull { it.ProductPrice?.FinalPrice!! }
            lowestMRPProduct = filteredInventory.value.minByOrNull { it.ProductPrice?.MRP!! }
            highestMRPProduct = filteredInventory.value.maxByOrNull { it.ProductPrice?.MRP!! }
        }
        var productMRP = product?.ProductPrice?.MRP.toString()
        var productFinalPrice = product?.ProductPrice?.FinalPrice.toString()

        if (filteredInventory.value.size == 1) {
            productMRP = lowestProduct?.ProductPrice?.MRP.toString()
            productFinalPrice = lowestProduct?.ProductPrice?.FinalPrice.toString()
            selectedInventory.value = filteredInventory.value[0]
        } else if (lowestProduct != null && highestProduct != null) {
            productMRP =
                "Range - ${lowestMRPProduct!!.ProductPrice?.MRP} - ${highestMRPProduct!!.ProductPrice?.MRP}"
            productFinalPrice =
                "Range - ${lowestProduct.ProductPrice?.FinalPrice} - ${highestProduct.ProductPrice?.FinalPrice}"
            selectedInventory.value = null
        }

        Column(modifier = Modifier.fillMaxSize().background(ThemeColor.shared().defaultBakground)) {
            TopNavBar(title = "Product", NavigationParam(), false, onBackPress = {
                AppNavigator.shared().goBack()
            },
//                onClickBlacklist = {
//                    AlertHandler.shared().showConfirmationAlert(
//                        localization().product.productConfirmTitle,
//                        localization().product.productConfirmMessage,
//                        onNegativeClick = {},
//                        onPositiveClick = {
//                            product?.IsBlacklisted = true
//                            viewModel.blacklistProduct(product) { isSuccess ->
//                                if (isSuccess) {
//                                    AppNavigator.shared().goBack()
//                                } else {
//                                    AlertHandler.shared().showAlert(
//                                        localization().product.productsAlertTitle,
//                                        localization().product.productsAlertMessage/*"Oops!", "Something went wrong"*/
//                                    )
//                                }
//                            }
//                        }
//                    )
//                }
            )
            AppLoader(viewModel)
            LazyColumn(modifier = Modifier.fillMaxSize().padding(bottom = 60.dp)) {
                item {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(230.dp)
                    ) {
                        ImageView(product?._id ?: "", product?.BusinessID,true)
                    }
                }
                item {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(55.dp)
                            .padding(4.dp),
                        verticalAlignment = Alignment.Bottom
                    )
                    {
                        Text(
                            product?.Name ?: "",
                            fontWeight = FontWeight.Bold,
                            fontSize = 18.sp,
                            modifier = Modifier
                                .weight(0.7f)
                        )
                        Text(
                            product?.ProductPrice?.FinalPrice.toString(),
                            fontSize = 24.sp,
                            fontWeight = FontWeight.Bold
                        )
                        Text(
                            "${product?.ProductPrice?.currency?.symbol} ${product?.ProductPrice?.MRP}",
                            fontSize = 16.sp,
                            color = Color.Gray,
                            modifier = Modifier
                                .weight(0.1f),
                            style = TextStyle(textDecoration = TextDecoration.LineThrough)
                        )
                    }
//                    Text(
//                        " ⭐ 4.5 • 100+ Reviews",
//                        fontSize = 16.sp,
//                        color = Color.Gray,
//                        modifier = Modifier
//                            .padding(bottom = 8.dp)
//                    )
                    HorizontalDivider(
                        modifier = Modifier
                            .padding(4.dp, 8.dp)
                            .background(color = Color.Gray),
                        thickness = 2.dp
                    )
                    Text(
                        product?.Description ?: "",
                        fontWeight = FontWeight.Normal,
                        fontSize = 18.sp,
                        modifier = Modifier
                            .weight(0.7f)
                    )
                    if (productInventory.value.size != 0) {
                        HorizontalDivider(
                            modifier = Modifier
                                .padding(4.dp, 8.dp)
                                .background(color = Color.Gray),
                            thickness = 2.dp
                        )
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(4.dp)
                                .background(color = ThemeColor.shared().defaultBakground)
                        ) {
                            Text(
                                "Color",
                                fontWeight = FontWeight.Bold,
                                fontSize = 18.sp,
                                modifier = Modifier
                                    .weight(0.5f)
                            )
                            Text(
                                "▼",
                                fontSize = 18.sp,
                                fontWeight = FontWeight.Bold,
                                modifier = Modifier
                            )
                        }
                        LazyRow(modifier = Modifier.fillMaxWidth().height(68.dp)) {
                            items(
                                dColors.count()
                            ) {
                                ColorCard(
                                    dColors[it],
                                    colorId.value,
                                    filteredInventory.value
                                ) { cId ->
                                    if (colorId.value == cId) {
                                        colorId.value = ""
                                    } else {
                                        colorId.value = cId ?: ""
                                    }
                                    findById()
                                }
                            }
                        }

                        HorizontalDivider(
                            modifier = Modifier
                                .padding(4.dp, 8.dp)
                                .background(color = Color.Gray),
                            thickness = 2.dp
                        )
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(4.dp)
                                .background(color = ThemeColor.shared().defaultBakground)
                        ) {
                            Text(
                                "Select Size",
                                fontWeight = FontWeight.Bold,
                                fontSize = 18.sp,
                                modifier = Modifier
                                    .weight(0.5f)
                            )
                            Text(
                                "▼",
                                fontSize = 18.sp,
                                fontWeight = FontWeight.Bold,
                                modifier = Modifier
                            )
                        }
                        LazyRow(modifier = Modifier.fillMaxWidth().height(68.dp)) {
                            items(
                                dSize.count()
                            ) {
                                SizeCard(
                                    dSize[it],
                                    selectedInventory.value,
                                    filteredInventory.value
                                ) { sId ->
                                    if (sizeId.value == sId) {
                                        sizeId.value = ""
                                    } else {
                                        sizeId.value = sId ?: ""
                                    }
                                    findById()
                                }
                            }
                        }

                        HorizontalDivider(
                            modifier = Modifier
                                .padding(4.dp, 8.dp)
                                .background(color = Color.Gray),
                            thickness = 2.dp
                        )
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(4.dp)
                                .background(color = ThemeColor.shared().defaultBakground)
                        ) {
                            Text(
                                "Select Unit of Measurement",
                                fontWeight = FontWeight.Bold,
                                fontSize = 18.sp,
                                modifier = Modifier
                                    .weight(0.5f)
                            )
                            Text(
                                "▼",
                                fontSize = 18.sp,
                                fontWeight = FontWeight.Bold,
                                modifier = Modifier
                            )
                        }
                        LazyRow(modifier = Modifier.fillMaxWidth().height(68.dp)) {
                            items(
                                dUoM.count()
                            ) {
                                UOMCard(
                                    dUoM[it],
                                    selectedInventory.value,
                                    filteredInventory.value
                                ) { uId ->
                                    if (uomId.value == uId) {
                                        uomId.value = ""
                                    } else {
                                        uomId.value = uId ?: ""
                                    }
                                    findById()
                                    // selectedInventory.value = inventory
                                }
                            }
                        }
                    }
                    HorizontalDivider(
                        modifier = Modifier
                            .padding(4.dp, 8.dp)
                            .background(color = Color.Gray),
                        thickness = 2.dp
                    )
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(4.dp)
                            .background(color = ThemeColor.shared().defaultBakground)
                    ) {
                        Text(
                            "Description",
                            fontWeight = FontWeight.Bold,
                            fontSize = 18.sp,
                            modifier = Modifier
                                .weight(0.5f)
                        )
                        Text(
                            "▼",
                            fontSize = 18.sp,
                            fontWeight = FontWeight.Bold,
                            modifier = Modifier
                        )
                    }
                    Text(
                        product?.Description ?: "",
                        fontSize = 14.sp,
                        color = Color.Gray
                    )
                    HorizontalDivider(
                        modifier = Modifier
                            .padding(4.dp, 8.dp)
                            .background(color = Color.Gray),
                        thickness = 3.dp
                    )
//                    Row(
//                        modifier = Modifier
//                            .fillMaxWidth()
//                            .padding(4.dp)
//                            .background(color = ThemeColor.shared().defaultBakground)
//                    ) {
//                        Text(
//                            "Reviews & Ratings",
//                            fontWeight = FontWeight.Bold,
//                            fontSize = 18.sp,
//                            modifier = Modifier
//                                .weight(0.5f)
//                        )
//                        Text(
//                            "▼",
//                            fontSize = 18.sp,
//                            fontWeight = FontWeight.Bold,
//                            modifier = Modifier
//                        )
//                    }
                }
//                item { FeedbackCard() }
//                item { FeedbackCard() }
//                item {
//
//                    Column(
//                        modifier = Modifier
//                            .fillMaxWidth().fillMaxHeight()
//                            .padding(4.dp)
//                            .background(color = ThemeColor.shared().defaultBakground)
//                    ) {
//                        HorizontalDivider(
//                            modifier = Modifier
//                                .padding(4.dp, 8.dp)
//                                .background(color = Color.Gray),
//                            thickness = 3.dp
//                        )
//                        Row {
//                            Text(
//                                "Similar Products",
//                                fontWeight = FontWeight.Bold,
//                                fontSize = 18.sp,
//                                modifier = Modifier
//                                    .weight(0.5f)
//                            )
//                            Text(
//                                "▼",
//                                fontSize = 18.sp,
//                                fontWeight = FontWeight.Bold,
//                                modifier = Modifier
//                            )
//                        }
//                    }
//                }
                item {
                    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight()) {
                        TextRow(
                            title = "Mrp",
                            message = "${product?.ProductPrice?.currency?.symbol} $productMRP"
                        )
                        TextRow(
                            title = "Final Price",
                            message = "${product?.ProductPrice?.currency?.symbol} $productFinalPrice"
                        )
                    }
                }
                item {
                    if (AppNavigator.shared().getNavigationParam().selectedBusiness._id == AppNavigator.shared().getNavigationParam()?.business?._id) {
                        Row(modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.16f)) {
                            SecondaryButton("Delete", {
                                product?.let {
                                    viewModel.deleteProduct(it) {
                                        AppNavigator.shared().goBack()
                                    }
                                }
                            })
                            DefaultButton("Edit"/*"Next"*/, onClick = {
                                viewModel.setEditProduct(product)
                                AppNavigator.shared().navigate(InventoryNavRoute.Product.UPDATE)
                            })
                        }
                        if (selectedInventory.value != null || productInventory.value.isEmpty()) {
                            Row(
                                modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.16f)
                                    .padding(top = 8.dp)
                            ) {
                                DefaultButton("Add to Cart", onClick = {
                                    cartViewModel.addToCart(
                                        product!!,
                                        NavigationParam(),
                                        selectedInventory.value
                                    ){
                                        print(it)
                                    }
                                })
                            }
                        }

                    }
                }
            }
        }
    }
}